<script setup lang="ts">
import { createCookieBanner } from '@lst/cookie-banner';
import { useApplicationStore } from '@/models/application-store';

import TheHeader from '@/components/layout/the-header.vue';
import TheFooter from '@/components/layout/the-footer.vue';

createCookieBanner();
useApplicationStore();

</script>

<template>
  <nuxt-layout>
    <background-video />
    <div id="toast-container"></div>

    <div class="wrap">
      <common-menu />

      <the-header />
      <nuxt-page />
      <the-footer />
    </div>
  </nuxt-layout>
</template>

<style scoped lang="postcss">
.wrap {
  height: 100dvh;

  display: grid;
  grid-template: auto 1fr auto / 1fr;
}
</style>
